/**
 * Valida apenas o formato de CPF ou CNPJ (não valida dígitos verificadores)
 * @param {string} value - Tax ID value (can contain formatting)
 * @returns {boolean} True if tax ID is in the correct format
 */
export const validateTaxId = (value) => {
  if (!value) return false;

  const cleanTaxId = value.replace(/\D/g, '');

  if (cleanTaxId.length === 11) {
    const cpfPattern = /^[0-9]{3}\.[0-9]{3}\.[0-9]{3}-[0-9]{2}$/;
    return cpfPattern.test(value);
  }

  if (cleanTaxId.length === 14) {
    const cnpjPattern = /^[0-9]{2}\.[0-9]{3}\.[0-9]{3}\/\d{4}-\d{2}$/;
    return cnpjPattern.test(value);
  }

  return false;
}; 
